import { useEffect, useRef, useState } from "react";

export default function DraggableDrawer({ children }) {
  const drawerRef = useRef(null);
  const minY = 80; // pokazuje uchwyt
  const maxY = 100; // pełne rozwinięcie (od góry)
  const [open, setOpen] = useState(false);

  const posY = useRef(window.innerHeight - minY);
  const startY = useRef(0);
  const lastY = useRef(0);
  const velocity = useRef(0);
  const dragging = useRef(false);

  // 🧠 Ustaw transform natywnie, bez setState
  const setDrawerY = (y) => {
    posY.current = y;
    if (drawerRef.current) {
      drawerRef.current.style.transform = `translateY(${y}px)`;
    }
  };

  const animateTo = (targetY) => {
    const step = () => {
      const current = posY.current;
      const diff = targetY - current;
      const move = diff * 0.15;

      if (Math.abs(diff) < 1) {
        setDrawerY(targetY);
        return;
      }

      setDrawerY(current + move);
      requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };

  const handleStart = (e) => {
    dragging.current = true;
    startY.current = e.touches ? e.touches[0].clientY : e.clientY;
    lastY.current = startY.current;
  };

  const handleMove = (e) => {
    if (!dragging.current) return;
    const currentY = e.touches ? e.touches[0].clientY : e.clientY;
    const delta = currentY - startY.current;
    const newY = Math.max(maxY, Math.min(window.innerHeight - minY, posY.current + delta));
    velocity.current = currentY - lastY.current;
    lastY.current = currentY;
    setDrawerY(newY);
  };

  const handleEnd = () => {
    dragging.current = false;
    const shouldOpen = velocity.current < -5 || posY.current < window.innerHeight / 2;
    setOpen(shouldOpen);
    const targetY = shouldOpen ? maxY : window.innerHeight - minY;
    animateTo(targetY);
  };

  useEffect(() => {
    setDrawerY(window.innerHeight - minY);

    window.addEventListener("mousemove", handleMove);
    window.addEventListener("mouseup", handleEnd);
    window.addEventListener("touchmove", handleMove);
    window.addEventListener("touchend", handleEnd);

    return () => {
      window.removeEventListener("mousemove", handleMove);
      window.removeEventListener("mouseup", handleEnd);
      window.removeEventListener("touchmove", handleMove);
      window.removeEventListener("touchend", handleEnd);
    };
  }, []);

  return (
    <div
      ref={drawerRef}
      style={{
        position: "fixed",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        backgroundColor: "#fff",
        borderTopLeftRadius: "20px",
        borderTopRightRadius: "20px",
        boxShadow: "0 -2px 10px rgba(0,0,0,0.15)",
        zIndex: 1000,
        touchAction: "none",
        transform: `translateY(${window.innerHeight - minY}px)`,
        transition: dragging.current ? "none" : "transform 0.2s ease-out",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      {/* 🔘 Uchwyt */}
      <div
        onMouseDown={handleStart}
        onTouchStart={handleStart}
        className="grab-btn"
      >
        <div
          className="draggable"
        />
      </div>

      <div style={{ flex: 1, overflowY: "auto", padding: "1rem" }}>
        {children}
      </div>
    </div>
  );
}
